import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileWrapper } from 'src/app/models/fileWrapper.model';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.less']
})

export class UploadFileComponent {

  @Input() isMinimized = false;
  @Input() isImageOnly = false;
  @Input() files: FileWrapper[] = [];
  @Input() filesMaxCount = 0;

  @Output() addFileEvent = new EventEmitter<any>();
  @Output() removeFileEvent = new EventEmitter<FileWrapper>();
  @Output() downloadFileEvent = new EventEmitter<FileWrapper>();

  isUserAboutToDropFile = false;
  maxSize: number = 10000000;

  @ViewChild('fileInput') fileInput: any;

  constructor(private translate: TranslateService) { }

  addFile(event: any) {
    if (this.isAllFilesAcceptedType(event.target.files) && this.isAllFilesAcceptedSize(event.target.files)
          && (this.filesMaxCount === 0 || this.files.length + event.target.files.length <= this.filesMaxCount)) {
      this.isUserAboutToDropFile = false;
      this.addFileEvent.emit(event);
    }

    this.fileInput.nativeElement.value = '';
  }

  removeFile(file: FileWrapper) {
    this.removeFileEvent.emit(file);
  }

  downloadFile(file: FileWrapper) {
    this.downloadFileEvent.emit(file);
  }

  dropEventContainsFiles(event: any) {
    if (event.dataTransfer.types) {
      for (let i = 0; i < event.dataTransfer.types.length; i++) {
        if (event.dataTransfer.types[i] === "Files") {
          return true;
        }
      }
    }
    return false;
  }

  isAllFilesAcceptedType(files: FileList) {
    let isAcceptedFiles = false;

    Array.from(files).forEach(file => {
      if (this.isAcceptedType(file)) {
        isAcceptedFiles = true;
      }
    });

    return isAcceptedFiles;
  }

  getAcceptedTypes() {
    return this.isImageOnly ? ["image"] : ["image", "pdf", "doc", "docx", "xlsx", "xls"];
  }

  getAcceptedInputTypes() {
    return this.getAcceptedTypes().map(type => type === "image" ? "image/*" : `.${type}`);
  }

  isAcceptedType(file: any) {
    let isAcceptedFile = false;

    this.getAcceptedTypes().forEach(type => {
      if (file.type.includes(type)) {
        isAcceptedFile = true;
      }
    });

    return isAcceptedFile;
  }

  isAllFilesAcceptedSize(files: FileList) {
    let isAcceptedSize = true;
    Array.from(files).forEach(file => {
      console.log("file size", file.size)
      if (file.size > this.maxSize) {
        isAcceptedSize = false;
      }
    });
    return isAcceptedSize;
  }

  getTitleText() {
    return this.translate.instant('DRAG YOUR FILE HERE');
  }

  getSubtitleText() {
    return this.translate.instant('OR CLICK THIS BUTTON TO BROWSE');
  }

  getFormatText() {
    return `${this.translate.instant('VALID FORMAT')}: ${this.getAcceptedTypes().join(" .")}`;
  }

  getSizeText() {
    return `${this.translate.instant('MAX FILE SIZE')}: ${this.maxSize / 1000000} MB`;
  }

  getTooltipText() {
    return `${this.getTitleText()}\n${this.getSubtitleText()}\n${this.getFormatText()}\n${this.getSizeText()}`;
  }
}
